import React from "react";
import { motion } from "framer-motion";
import { FiUserX } from "react-icons/fi";

const EmptyAssignedRoles = ({ onAssignClick, msg }) => {
  return (
    <motion.div
      className="text-center py-4"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className="d-flex justify-content-center align-items-center mb-3">
        <FiUserX size={48} color="#6c757d" />
      </div>
      <h5 style={{ color: "#6c757d", fontWeight: 500 }}>No roles assigned yet</h5>
      <p className="text-muted-theme" style={{ fontSize: "0.95rem" }}>
        {msg}
      </p>
      <button
        className="btn btn-outline-primary mt-2 j_g_rT_asBtn"
        onClick={onAssignClick}
      >
        + Assign Roles
      </button>
    </motion.div>
  );
};

export default EmptyAssignedRoles;
